import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HeaderComponent } from '../../components/header/header.component';

@Component({
  selector: 'app-about',
  imports: [
    TranslatePipe,
    HeaderComponent
  ],
  templateUrl: './about.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './about.component.scss'
})
export class AboutComponent {

  back(){
    history.back();
  }

}
